import XEUtils from 'xe-utils'

import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
import httpManager from '../../util/common'
import {reportYear} from "../../util/util";
import { isNumber } from 'xe-utils/methods'
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {
    report_date: Array,
    oaids: Array,
    report_type: String,
    selectEvent: Boolean,
  },
  data: () => {
    return {
      loading: false,
      ticker: '',
      data: [],
      tableColumn: [],
      gics: null,
      national_economic: null,
      exportConfig: {},
      indicator1: {
        'Inspection': '审验',
        'Assurance': '鉴证',
        'OtherExamination': '其他验证',
        'UnqualifiedOpinion': '\u6807\u51c6\u65e0\u4fdd\u7559\u610f\u89c1',
        'UnqualifiedOpinionWithExplanatoryParagraph': '\u5e26\u5f3a\u8c03\u4e8b\u9879\u6bb5\u7684\u65e0\u4fdd\u7559\u610f\u89c1',
        'QualifiedOpinion': '\u4fdd\u7559\u610f\u89c1',
        'DisclaimerOpinion': '\u65e0\u6cd5\u8868\u793a\u610f\u89c1',
        'AdverseOpinion': '\u5426\u5b9a\u610f\u89c1',
      }
    }
  },
  methods: {
    cellClickEvent({column, columnIndex}) {
      if(column.level === 1 && columnIndex > 3){
        const { href } = this.$router.resolve({path:  '/entity/'+column.title+'/home'})
      window.open(href, '_blank')
      }
    },
    openDataExport() {
      let s = "ESG-indication-"+this.report_type+"-"
      this.$refs.xTree.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    setAllTreeExpand() {
      this.$refs.xTree.setAllTreeExpand(true)
    },
    formatterDate({cellValue}, format) {
      return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
    },
    getGics(){
      let self = this
      reportYear.gics().then(result => {
            self.gics =result
      })
    },
    getEconomyIndustry() {
      let self = this
      reportYear.national_economic().then(result => {
        self.national_economic = result
      })
    },
    transCodeToName(code) {
      let arrays = this.national_economic
      for(let index1 in arrays) {
        if(code && code[0] == arrays[index1].value) {
          let array = arrays[index1].children
          for(let index2 in array){
            if(code == array[index2].value) {
              code = array[index2].label
              return code
            }
          }
        }
      }
      return code
    },
    trans_data(data) {
      for (let i in data) {
        let item = data[i]
        for (let key in item) {
          if (this.$i18n.locale === 'zh') {
            if (typeof item[key] == 'boolean') {
              item[key] = item[key] ? '是' : '否'
            }
          }
          if (typeof item[key] == 'number' & item[key] > 1000 & item['id'] !== 'report_year') {
            item[key] = XEUtils.commafy(item[key], {digits: 2})
          }
          if (this.$i18n.locale === 'zh') {
            if (item[key] in this.indicator1) {
              item[key] = this.indicator1[item[key]]
            }
          }
          if (item[key] in this.gics & item['id'] === 'gics') {
            item[key] = this.gics[item[key]][this.$i18n.locale]+"-"+item[key]
          }
          if(item['id'] === 'industry_co_code' && key.includes(' ')) {
              item[key] = this.transCodeToName(item[key])
          }
        }
      }
      return data
    },
    getESGData() {
      let self = this
      self.loading = true
      self.data = null
      self.tableColumn = []
      let params = new Map()
      params.set("lang", this.$i18n.locale)
      let urlDef = "esg_entity_indicator_annual"
      if(!self.report_type) {
        urlDef = "esg_private_entity_indicators"
      }else if (self.report_type === 'monthly') {
        urlDef = "esg_entity_indicator_monthly"
        let report_month = []
        for(let i in self.report_date){
          let d = self.report_date[i].split('-')
          report_month.push(d[0] + "-" + d[1])
        }
        params.set("report_month", report_month)
      }else if(self.report_type === 'bondissuer'){
        urlDef = "esg_bondissuer_indicator_annual"
      }else{
        if (self.report_date) {
        params.set("report_year", self.report_date)
      }
      }
      let promises = []
      let dataList = []
      let columnList = []
      for (let i in self.oaids) {
        let oaid = self.oaids[i]
        params.set("oaid", oaid)
        let promise1 = httpManager(urlDef, params, null, null, null)
          .then(response => {
            dataList[i] = response.data.data
            columnList[i] = response.data.columns
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
        promises.push(promise1)
      }
      self.data = []
      self.tableColumn = []
      Promise.all(promises).then(function (values) {
        self.data = self.mergeDataList(dataList)
        self.tableColumn = self.mergeColumnList(columnList)
        self.data = self.trans_data(self.data)
        if(!self.ticker || self.ticker == "undefined"){
          self.tableColumn.forEach(element => {
            let formatter = ({cellValue}) => {
              if((!isNaN(cellValue) || isNumber(cellValue)) && cellValue !='' && cellValue != null) {
                let num = Number(cellValue)
                if(num % 1 === 0) return num
                return num.toFixed(4).toLocaleLowerCase()
              }
              return cellValue
            }
            element['formatter'] = formatter
          })
        }

      });
    },
    mergeDataList(dataList) {
      let dataDict = {}
      for (let i in dataList) {
        let datal = dataList[i]
        for (let j in datal) {
          let id = datal[j].id
          if (id in dataDict) {
            for (let key in datal[j]) {
              dataDict[id][key] = datal[j][key]
            }
          } else {
            dataDict[id] = datal[j]
          }
        }
      }
      let re = []
      for (let key in dataDict) {
        re.push(dataDict[key])
      }
      return re
    },
    mergeColumnList(columnList) {
      let columnDict = {}
      for (let i in columnList) {
        let columnl = columnList[i]
        for (let j in columnl) {
          let field = columnl[j].field
          if (field in columnDict) {
          } else {
            columnDict[field] = columnl[j]
          }
        }
      }
      let re = []
      for (let key in columnDict) {
        re.push(columnDict[key])
      }
      return re
    },
    getTicker() {
      this.ticker = sessionStorage.getItem("ticker") ? sessionStorage.getItem("ticker"):''
    }
  },
  mounted() {
    if(this.oaids.length != 0){
      this.getTicker()
      this.getEconomyIndustry()
      this.getGics()
      this.getESGData()
    }
  },
  watch: {
    selectEvent: function () {
      this.getESGData()
    },
    national_economic: function() {
      this.data = this.trans_data(this.data)
    }
  }
}
Vue.component("esg-indication-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_indication_table.js